import { Image } from 'expo-image';
import { useMemo, useState } from 'react';
import {
  View, Text, StyleSheet, FlatList, Pressable, Dimensions,
  TouchableOpacity, ActivityIndicator
} from 'react-native';
import { PayAPI } from '../data/payApi';
import { Modal, Toast } from 'native-base';
import { useTypedSelector } from '../redux/store';

let { width } = Dimensions.get('window');
if(width > 460){ width = 460; }
const COLUMN_WIDTH = width / 2 - 20;

export default function GemScreen() {
  const cacheData = useMemo(()=>[
    { id: "1", name: "10,000 Coin", price: "$10.00", pay_key: "price_1RERENK9oh0lFlzBugEU8z6V" },
    { id: "2", name: "55,000 Coin", price: "$50.00 (10% More)", pay_key: "price_1RERFeK9oh0lFlzBpJm1u7GM" },
    { id: "3", name: "120,000 Coin", price: "$100.00 (20% More)", pay_key: "price_1RERGgK9oh0lFlzBZI0I3BGX" },
  ],[]);
  const [checkoutPlan, setCheckoutPlan] = useState(cacheData[0]);
  const [payLoad, setPayLoad] = useState(false);
  const userCurrent = useTypedSelector((state) => state.userCurrent);

  const payChange = async ()=>{
    if(payLoad) return;
    setPayLoad(true);
    let res = await PayAPI.getPlanUrl(checkoutPlan.pay_key, "payment");
    if(res && res.url){
      window.location.href = res.url;
    }else{
      setPayLoad(false);
      Toast.show({
        title: "Pay failed",
        placement: "top",
        bgColor: "rgba(255,0,0,0.4)" 
      })
    }
    // TODO: pay
  }

  const renderItem = ({
    item
  }:{
    item: typeof cacheData[number]
  })=>(
    <Pressable
      onPress={()=> setCheckoutPlan(item) }>
      <View style={{
        gap: 10, alignItems: "center", width: COLUMN_WIDTH,
        padding: 12, margin: 5, position: "relative",
        borderWidth: 2,
        borderRadius: 12,
        borderColor: checkoutPlan.pay_key === item.pay_key ? "rgb(179,88,251)" : "transparent",
        backgroundColor: "#24263B",
      }}>
        <Text style={{ fontSize: 14, color: "#FFFFFF", fontWeight: "bold" }}>
          {item.name}
        </Text>
        <Text style={{ fontSize: 13, color: "#FFFFFF", fontWeight: "bold" }}>
          {item.price}
        </Text>
      </View>
    </Pressable>
  )

  return (
    <View style={styles.container}>
      <View style={{ alignItems: "center", marginTop: 20 }}>
        <Image style={{ width: 80, height: 80 }}
          source={ require('../assets/material/more-coin.png') }
        />
        <View style={{
          flexDirection: "row", gap: 10, alignItems: "center",
          marginTop: 4,
        }}>
          <Text style={{ color: "#FFFFFF", fontSize: 24, fontWeight: "bold"}}>
            {userCurrent.coins}
          </Text>
        </View>
      </View>
      <FlatList
        data={cacheData}
        renderItem={renderItem}
        numColumns={2}
        keyExtractor={(item)=> item.name}
        style={{ marginTop: 20, padding: 10, flexGrow: 0 }}
      />
      <View style={{ padding: 15, paddingTop: 0 }}>
        <TouchableOpacity style={{
          height: 50, borderRadius: 10, paddingLeft: 10, paddingRight: 10,
          backgroundImage: "linear-gradient(to bottom, rgb(148,9,255), rgb(173,8,255))",
          flexDirection: "row", gap: 10, marginBottom: 6,
          alignItems: "center", justifyContent: "center"
        }} onPress={payChange}>
          <Text style={{
            fontSize: 18, color: "#FFFFFF", fontWeight: "700"
          }}>
            Pay {checkoutPlan.price}
          </Text>
        </TouchableOpacity>
      </View>
      <Modal isOpen={payLoad} size="full" bg="black.700:alpha.70"
        justifyContent="center" alignItems="center"
        style={{
          width: "100%", maxWidth: 460,
          marginLeft: "auto", marginRight: "auto",
        }}>
        <ActivityIndicator size="large" color="#FFFFFF" />
      </Modal>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#191B2C',
  }
});